import { ReportKpi, ReportKpiBody, ReportKpiHeader } from '@/components/custom/report';
import { Skeleton } from '@/components/ui/skeleton';

export function ReportKpiSkeleton() {
  return (
    <ReportKpi>
      <ReportKpiHeader>
        <Skeleton className="h-9 w-12" />
        <Skeleton className="h-4 grow" />
      </ReportKpiHeader>
      <ReportKpiBody>
        <Skeleton className="h-12" />
      </ReportKpiBody>
    </ReportKpi>
  );
}
